import React from 'react';

const PATCH_FLAG = '__imPagesPlaceholderHydrationPatched';

function shouldSuppressPagesHydration(
  type: unknown,
  props: Record<string, unknown> | null | undefined
): boolean {
  if (!props) {
    return false;
  }
  const className = props.className;
  if (typeof className !== 'string') {
    return false;
  }
  if (type === 'div' && className.includes('sc-jss-empty-placeholder')) {
    return true;
  }
  if (type === 'code' && className.split(/\s+/).includes('scpm')) {
    return true;
  }
  return false;
}

/**
 * SDK 2.0.2 creates `sc-jss-empty-placeholder` and PlaceholderMetadata `<code class="scpm">`
 * after our `renderEmpty`, so app code cannot put `suppressHydrationWarning` on those hosts
 * without wrapping (which breaks Pages chromes). Content SDK PR #578 does this in the SDK;
 * until that release, patch createElement (what the SDK dist uses) so the existing nodes
 * get the prop with no extra DOM.
 */
const reactWithFlag = React as typeof React & { [PATCH_FLAG]?: boolean };

if (!reactWithFlag[PATCH_FLAG]) {
  const originalCreateElement = React.createElement;
  const patchedCreateElement = ((
    type: React.ElementType,
    props: Record<string, unknown> | null,
    ...children: React.ReactNode[]
  ) => {
    const nextProps =
      shouldSuppressPagesHydration(type, props) && props
        ? { ...props, suppressHydrationWarning: true }
        : props;
    return originalCreateElement(type, nextProps, ...children);
  }) as typeof React.createElement;

  React.createElement = patchedCreateElement;
  reactWithFlag[PATCH_FLAG] = true;
}
